import { FileCheck2, Loader2 } from "lucide-react";
import { useResumeUpload } from "@/components/resume/useResumeUpload";
import { ReadinessResult } from "@/components/resume/ReadinessResult";
import { ResumeFilePicker, JobDescriptionField, ResumeConsent } from "@/components/resume/ResumeUploadFields";

const UploadSuccess = ({ result, className, prefix }) => (
  <div className={className} data-testid={`${prefix}-upload-success`}>
    <div className="flex items-center gap-3 rounded-xl border border-border bg-blue-50 p-5">
      <FileCheck2 className="h-6 w-6 shrink-0 text-blue-600" />
      <div>
        <p className="font-semibold text-slate-900">Resume received.</p>
        <p className="text-sm text-slate-600">Reference: <span className="font-mono text-slate-800" data-testid={`${prefix}-reference`}>{result?.submission_id}</span></p>
      </div>
    </div>
    <ReadinessResult readiness={result?.readiness} prefix={prefix === "resume" ? "readiness" : `${prefix}-readiness`} />
  </div>
);

export const ResumeUpload = ({ source = "candidate-journey", name = "", email = "", phone = "",
  allowJobDescription = true, className = "", testIdPrefix = "resume" }) => {
  const upload = useResumeUpload({ source, name, email, phone });
  if (upload.status === "done") return <UploadSuccess result={upload.result} className={className} prefix={testIdPrefix} />;
  const uploading = upload.status === "uploading";
  return (
    <div className={className} data-testid={`${testIdPrefix}-upload`}>
      <ResumeFilePicker upload={upload} prefix={testIdPrefix} />
      {allowJobDescription && <JobDescriptionField upload={upload} prefix={testIdPrefix} />}
      <ResumeConsent upload={upload} prefix={testIdPrefix} />
      <button type="button" onClick={upload.submit} disabled={!upload.file || !upload.consent || uploading} data-testid={`${testIdPrefix}-submit`}
        className="mt-4 inline-flex items-center gap-2 rounded-full bg-primary px-7 py-3 text-sm font-medium text-primary-foreground transition-[background-color] hover:bg-blue-700 disabled:cursor-not-allowed disabled:opacity-50">
        {uploading && <Loader2 className="h-4 w-4 animate-spin" />}
        {uploading ? "Checking…" : "Upload & check readiness"}
      </button>
    </div>
  );
};